const MENTOR = 'Mentor';
const MENTEE = 'Mentee';

const equalsIgnoreCase = (a, b) => a && (a.toLowerCase() === b.toLowerCase());

export const isMentee = (role) => equalsIgnoreCase(role, MENTEE);

export const isMentor = (role) => equalsIgnoreCase(role, MENTOR);
